import React from 'react';
import { motion, MotionConfig, Variants } from 'framer-motion';

interface AnimatedHamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

interface SpanVariants {
  open: {
    rotate?: string[];
    top?: string[];
    bottom?: string[];
    left?: string;
  };
  closed: {
    rotate?: string[];
    top?: string[];
    bottom?: string[];
    left?: string;
  };
}

const VARIANTS: Record<string, SpanVariants> = {
  top: {
    open: {
      rotate: ['0deg', '0deg', '45deg'],
      top: ['30%', '50%', '50%'],
    },
    closed: {
      rotate: ['45deg', '0deg', '0deg'],
      top: ['50%', '50%', '20%'],
    },
  },
  middle: {
    open: {
      rotate: ['0deg', '0deg', '-45deg'],
    },
    closed: {
      rotate: ['-45deg', '0deg', '0deg'],
    },
  },
  bottom: {
    open: {
      rotate: ['0deg', '0deg', '45deg'],
      bottom: ['30%', '50%', '50%'],
      left: '50%',
    },
    closed: {
      rotate: ['45deg', '0deg', '0deg'],
      bottom: ['50%', '50%', '20%'],
      left: 'calc(50% + 7px)',
    },
  },
};

const AnimatedHamburgerButton: React.FC<AnimatedHamburgerButtonProps> = ({ isOpen, onClick }) => {
  return (
    <MotionConfig
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
      }}
    >
      <motion.button
        aria-label="Open menu"
        initial={false}
        animate={isOpen ? 'open' : 'closed'}
        onClick={onClick}
        data-menu="Mobile Open"
        className="ga-menu-mobile relative h-[25px] w-[25px] transition-colors sm:h-[30px] sm:w-[30px]"
      >
        <motion.span
          variants={VARIANTS.top as unknown as Variants}
          className="pointer-events-none absolute h-[3px] w-[25px] bg-white sm:w-[30px]"
          style={{ y: '-50%', left: '50%', x: '-50%', top: '30%' }}
        />
        <motion.span
          variants={VARIANTS.middle as unknown as Variants}
          className="pointer-events-none absolute h-[3px] w-[25px] bg-white sm:w-[30px]"
          style={{ left: '50%', x: '-50%', top: '50%', y: '-50%' }}
        />
        <motion.span
          variants={VARIANTS.bottom as unknown as Variants}
          className="pointer-events-none absolute h-[3px] w-[10px] bg-white sm:w-[15px]"
          style={{
            x: '-50%',
            y: '50%',
            bottom: '25%',
            left: 'calc(50% + 7px)',
          }}
        />
      </motion.button>
    </MotionConfig>
  );
};

export default AnimatedHamburgerButton;
